
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";
import { useI18n } from "vue-i18n";
import { RootActions } from "@/store/actions";
import { EventBus } from "./eventBus";
import config from "../../images/configuration.json";
import { LoginActions } from "@/modules/login/store/types";
import { RootGetters } from "@/store/getters";

export default defineComponent({
  name: "App",
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local",
    });
    return { t };
  },
  data() {
    return {
      config,
    };
  },
  computed: {
    ...mapGetters({
      isFirstRead: RootGetters.IS_FIRST_READ,
    }),
  },
  methods: {
    ...mapActions({
      setQueryParams: RootActions.SET_QUERY_PARAMS,
      setConfig: RootActions.SET_CONFIG,
      fetchHeatmapsConfig: RootActions.FETCH_HEATMAPS_CONFIG,
      setError: RootActions.SET_ERROR,
    }),
    ...mapActions("loginModule", {
      logout: LoginActions.LOGOUT,
    }),
  },
  beforeMount() {
    this.setConfig({ config });
    this.fetchHeatmapsConfig();
    this.setQueryParams(new URLSearchParams(window.location.search));
  },
  mounted() {
    // prevent navigating back to the login screen
    window.onpopstate = (event) => {
      if (event.state.current === "/login") {
        this.$router.push("/");
      }
    };
    document
      .getElementById("app")
      .addEventListener("event-bridge-api", (event: CustomEvent) => {
        const evdentDetail = event.detail;
        EventBus.emit(evdentDetail.eventName, evdentDetail.data);
      });
    EventBus.on(
      "event-bridge-api",
      (event: { eventName: String; data: any }) => {
        const customEvent = new CustomEvent("event-bridge-api", {
          bubbles: false,
          detail: { eventName: event.eventName, data: event.data },
        });
        document.body.dispatchEvent(customEvent);
      }
    );
    EventBus.on("error", (data: any) => {
      this.setError(data.errorText);
    });
    EventBus.on("logout", () => {
      this.logout();
    });
    this.$root.$i18n.locale = window.localStorage.locale
      ? window.localStorage.locale
      : process.env.VUE_APP_I18N_LOCALE;
  },
});
